import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import DetailsTaskOperationSatiaScreen from "../DetailsTaskOperationSatiaScreen";
import * as NavigationService from '../../../../../redux/NavigationService';


const mapStateToProps = (state) => ({
    results: state.reducerDetailsTaskOperationSatiaScreen.results,
    isLoading: state.reducerDetailsTaskOperationSatiaScreen.isLoading,
    NoInternetDialog: state.reducerDetailsTaskOperationSatiaScreen.NoInternetDialog,

    resultsSet: state.reducerDetailsTaskOperationSatiaScreen.resultsSet,
    isLoadingSet: state.reducerDetailsTaskOperationSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerDetailsTaskOperationSatiaScreen.NoInternetDialogSet,

    position: state.reducerDetailsTaskOperationSatiaScreen.position,
    id_category: state.reducerDetailsTaskOperationSatiaScreen.id_category,


    positionPersonnel: state.reducerDetailsTaskOperationSatiaScreen.positionPersonnel,
    id_Personnel: state.reducerDetailsTaskOperationSatiaScreen.id_Personnel,

    CartList: state.reducerSplashSatiaScreen.CartList,
    PriceAll: state.reducerSplashSatiaScreen.PriceAll,

    user: state.reducerSplashSatiaScreen.user,
    token: state.reducerSplashSatiaScreen.token,
    wallet: state.reducerSplashSatiaScreen.wallet,
    DataSplashScreen: state.reducerSplashSatiaScreen,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashSatiaScreen.FoodItem,

    listTask: state.reducerListTaskOperationSatiaScreen.results,

});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token, func, noLading) => dispatch(callWebservice(url, params, type, typeConnection, token, func, noLading)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token, func, noLading) => {

    switch (type) {
        case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
            if (!noLading)
                dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetDetailsTaskOperationSatiaScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    let formData = new FormData();
    // formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    //  formData.append('mode', params.mode);
    formData.append('Serial', params.Serial);
    formData.append('ReferTo', params.ReferTo);
    formData.append('OpRef', params.OpRef);
    formData.append('Serial_resend', params.Serial_resend ? params.Serial_resend : null);
    formData.append('customValue', params.customValue ? params.customValue : null);
    //   formData.append('state_params', params.state_params);
    formData.append('token', params.token == null ? '' : params.token);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
        }
    };


    /*  axios(
          {
              // url: baseUrl + url + params,
              //url: url + "&after=0000-00-00",
              // url: url+`&${params.page}&${params.after}` ,
              url: url + params,
              // params:params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    // axios.post(url, formData, config)

    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
        .then(response => {
            let data = response.data;
            switch (type) {
                case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
                    if (data.status) {
                        //global._refreshSplashSatiaOperator = true;
                        global._refreshSplashSatiaOperator=true;
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccess(data));
                        //  NavigationService.navigateParams("SubmitSwitchingOperationScreen", {item: params.state_params.item,res:data})
                        func ? func(data.resultTasks) : null;

                        //   NavigationService.navigatereset('MainStack');
                    }
                    else {
                        switch (type) {
                            case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
                                dispatch(serviceActionError(response))

                                break;

                            case typeExport.TypeSetDetailsTaskOperationSatiaScreen:
                                dispatch(serviceActionErrorSet(response))

                                break;

                            default:
                        }
                    }
                    break;

                case typeExport.TypeSetDetailsTaskOperationSatiaScreen:

                    break;

                default:
            }
        }).catch((e) => {
        console.log("error", e)

        switch (type) {
            case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetDetailsTaskOperationSatiaScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token, func, noLading) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token, func, noLading);
        }
        else {
            switch (type) {
                case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetDetailsTaskOperationSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetDetailsTaskOperationSatiaScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.DetailsTaskOperationSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(DetailsTaskOperationSatiaScreen);
